'use strict'

export class CommonHelper {

  deleteByObjKey(params, deleteKey) {
    var objKey = Object.keys(params)
    var newObjKey = objKey.reduce((object, key) => {
      if(key !== deleteKey)
        object[key] = params[key]
      return object
    }, {})

    return newObjKey
  }

  toTitleCase(str) {
    return str.replace(/(^|\s)\S/g, function(t) { return t.toUpperCase() })
  }

  isValidURL(str) {
    var regexp =  /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
    return regexp.test(str)
  }

  replaceBlankValues(obj) {
    var defaultStr = 'none'
    Object.keys(obj).forEach(function(key){
      obj[key] = obj[key] || defaultStr
    })
    return obj
  }

  groupBy(xs, f) {
    return xs.reduce((r, v, i, a, k = f(v)) => ((r[k] || (r[k] = [])).push(v), r), {})
  }

}



// WEBPACK FOOTER //
// ./src/api/helper/CommonHelper.js